export const STANDARD_OPPORTUNITY_FIELDS = [
    { key: 'title', label: 'Título', form: true, summary: false, required: true, canHide: false },
    { key: 'description', label: 'Descrição', form: true, summary: true, required: false, canHide: true },
    { key: 'value', label: 'Valor estimado', form: true, summary: true, required: false, canHide: true },
    { key: 'owner', label: 'Vendedor', form: true, summary: true, required: false, canHide: true },
    { key: 'contact', label: 'Contato', form: true, summary: true, required: false, canHide: true },
    { key: 'contact_enterprise', label: 'Empresa', form: true, summary: true, required: false, canHide: true },
    { key: 'secondary_contacts', label: 'Outros contatos', form: true, summary: false, required: false, canHide: true },
    { key: 'created_at', label: 'Criado em', form: false, summary: true, required: false, canHide: false },
    { key: 'created_by', label: 'Criado por', form: false, summary: true, required: false, canHide: false },
    { key: 'estimated_at', label: 'Estimado para', form: true, summary: true, required: false, canHide: true },
    { key: 'closed_at', label: 'Fechado em', form: true, summary: true, required: false, canHide: true },
    { key: 'status', label: 'Status', form: true, summary: false, required: false, canHide: true },
]

export const STANDARD_FIELD_MAP = STANDARD_OPPORTUNITY_FIELDS.reduce((acc, field) => {
    acc[field.key] = field
    return acc
}, {})

export const getStandardFieldSettings = (journey) => {
    const settings = journey?.standard_opportunity_fields_settings
    return settings && typeof settings === 'object' && !Array.isArray(settings) ? settings : {}
}

export const getStandardFieldConfig = (journey, key) => {
    const field = STANDARD_FIELD_MAP[key] || { key, label: key, form: true, summary: true, required: false, canHide: true }
    const settings = getStandardFieldSettings(journey)
    return {
        ...field,
        ...(settings[key] || {}),
    }
}

export const getStandardFieldLabel = (journey, key) => getStandardFieldConfig(journey, key).label

export const isStandardFieldRequired = (journey, key) => {
    const field = STANDARD_FIELD_MAP[key]
    return field?.required === true || (Array.isArray(journey?.required_opportunity_fields) && journey.required_opportunity_fields.includes(key))
}

export const isStandardFieldHidden = (journey, key) => {
    const config = getStandardFieldConfig(journey, key)
    if (!config.form) return true
    if (config.canHide === false || isStandardFieldRequired(journey, key)) return false
    return config.hidden === true
}

export const isStandardFieldSummaryVisible = (journey, key) => {
    const config = getStandardFieldConfig(journey, key)
    if (!config.summary) return false
    if (config.canHide !== false && config.hidden === true) return false
    if (isStandardFieldRequired(journey, key)) return true
    return config.show_in_summary !== false
}

export const normalizeStandardFieldSettingsForSave = (settings) => {
    const normalized = {}

    Object.entries(settings || {}).forEach(([key, config]) => {
        if (!config || typeof config !== 'object' || Array.isArray(config)) return

        const fieldConfig = { ...config }

        if ('label' in fieldConfig) {
            const label = String(fieldConfig.label || '').trim()
            const defaultLabel = STANDARD_FIELD_MAP[key]?.label
            if (label && label !== defaultLabel) {
                fieldConfig.label = label
            } else {
                delete fieldConfig.label
            }
        }

        if (Object.keys(fieldConfig).length) {
            normalized[key] = fieldConfig
        }
    })

    return normalized
}

export const setStandardFieldSettingValue = (settings, key, property, value) => ({
    ...(settings || {}),
    [key]: {
        ...((settings || {})[key] || {}),
        [property]: value,
    },
})
